import {useState, useEffect, useCallback} from "react";
import {TicketDetails} from "../TicketModels";
import ticketApi from "../api/ticketAPI";
import {HttpErrorType} from "@/util/errorUtil";

interface UseTicketDetailsOptions {
    locationId?: number;
    businessDate?: string;
    ticketNumber?: number;
}

export const useTicketDetails = ({
    locationId,
    businessDate,
    ticketNumber
}: UseTicketDetailsOptions) => {
    const [data, setData] = useState<TicketDetails | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorStatus, setErrorStatus] = useState<number | null>(null);

    const fetchTicketDetails = useCallback(async () => {
        if (!locationId || !businessDate || !ticketNumber) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(false);

        try {
            const ticketDetails = await ticketApi.getTicketDetails(
                locationId,
                businessDate,
                ticketNumber
            );
            setData(ticketDetails);
            setError(false);
            setErrorStatus(null);
        } catch (err: any) {
            if (err.name !== HttpErrorType.Abort) {
                setError(true);
                setErrorStatus(err.status ?? null);
                setData(null);
            }
        } finally {
            setLoading(false);
        }
    }, [locationId, businessDate, ticketNumber]);

    useEffect(() => {
        fetchTicketDetails();
    }, [fetchTicketDetails]);

    return {data, loading, error, errorStatus};
};
